import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
export type { FormErrors, FormInput } from './types';

const loader = lazyForPaint(
    () => {
        return import(/* webpackChunkName: "request-create-form" */ /* webpackPrefetch: true */ './hocs');
    },
    {
        ssr: true,
    }
);
export const RequestCreateForm = withAsync({
    loader,
});
